// Red/Amber/Green light for the on-demand model an AGENT's chat is bound to.
// Mounted in the agent chat header so a user who sends a message to a
// scaled-to-zero model sees it's *warming up* (not broken). Polls
// agentApi.agentServingStatus(agentId) — which returns {on_demand:false} when
// the agent isn't on an on-demand model, in which case this renders nothing.
// Reuses ServingLightView so the dot + warm-up sequence match the admin light.
import { useEffect, useRef, useState } from "react";
import { agentApi } from "../../api/client";
import { ServingLightView } from "./ModelServingLight";

export default function AgentServingLight({ agentId, pollMs = 6000, warmingPollMs = 4000 }) {
  const [status, setStatus] = useState(null);   // null until first on-demand response
  const timer = useRef(null);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const res = await agentApi.agentServingStatus(agentId);
        if (!alive) return;
        const data = res?.data || res;
        // Not on an on-demand model → hide the light entirely.
        const st = data && data.on_demand ? data : null;
        setStatus(st);
        clearInterval(timer.current);
        // Only keep polling while this agent IS on an on-demand model — a plain
        // agent needs no live light, so stop after the first check (avoids a
        // forever-poll on every chat). A reload picks up a later on-demand switch.
        if (st) timer.current = setInterval(load, st.light === "amber" ? warmingPollMs : pollMs);
      } catch (_e) {
        // Header light is a nicety — swallow errors, show nothing, and retry at
        // the base cadence so a transient blip doesn't kill the light for good.
        if (alive) { setStatus(null); clearInterval(timer.current); timer.current = setInterval(load, pollMs); }
      }
    };
    load();
    return () => { alive = false; clearInterval(timer.current); };
  }, [agentId, pollMs, warmingPollMs]);

  if (!status) return null;
  return <ServingLightView status={status} />;
}
